import { render, staticRenderFns } from "./CoreLoader.vue?vue&type=template&id=158cdb7f&scoped=true&"
import script from "./CoreLoader.vue?vue&type=script&lang=js&"
export * from "./CoreLoader.vue?vue&type=script&lang=js&"
import style0 from "./CoreLoader.vue?vue&type=style&index=0&id=158cdb7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158cdb7f",
  null
  
)

export default component.exports